import React from'react';import PropTypes from'prop-types';import styles from"./style";/**
 * Renders the card component.
 * @param {Object} props The component properties.
 * @returns {JSX}
 */var Card=function Card(_ref){var className=_ref.className,children=_ref.children,id=_ref.id;return React.createElement("div",{className:"".concat(styles," ").concat(className),id:id},children);};Card.defaultProps={className:'',id:null};export default Card;